<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เพิ่มข้อมูลเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_danger === true">ลบข้อมูลเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <div class="mt-6">
        <v-card elevation="6">
          <div class="pa-3">
            <div class="pa-4">
              <span style="font-size: 24px">เงื่อนไขพิเศษ</span>
            </div>
            <div v-for="(count,index) in getCondition_list" :key="index">
              <div v-if="!count.is_delete == 1" class="grid_col mt-4">
                <div class="mt-3 mr-1">
                  <!-- <v-autocomplete color="#8cc63e" :items="getUnit_condition" item-text="name" item-value="unit_id" label="หน่วยนับ" hide-details="auto" @change="sendParameter(count.id, count.more_amount, count.unit_id, count.retail_price, count.cash_price, count.credit_price)" v-model="count.unit_id" outlined/> -->
                  <v-autocomplete color="#8cc63e" :items="getUnit_condition" item-text="name" item-value="unit_id" label="หน่วยนับ" hide-details="auto" @change="sendParameter()" v-model="count.unit_id" outlined/>
                </div>
                <div class="mt-3 mr-1" v-if="count.unit_id == null">
                  <v-text-field color="#8cc63e" type="number" pattern="[0-9]*" label="จำนวนมากกว่า" hide-details="auto" @keypress="isOnlyNumber($event)" @input="sendParameter()" v-model="count.more_amount" disabled outlined></v-text-field>
                </div>
                <div class="mt-3 mr-1" v-if="count.unit_id != null">
                  <v-text-field color="#8cc63e" type="number" pattern="[0-9]*" label="จำนวนมากกว่า" hide-details="auto" @keypress="isOnlyNumber($event)" @input="sendParameter()" v-model="count.more_amount" outlined></v-text-field>
                </div>

                <div class="mt-3 mr-1" v-if="count.unit_id == null">
                  <v-text-field color="#8cc63e" type="number" pattern="[0-9]*" label="ราคาปลีก"  hide-details="auto" @keypress="isCurrency($event, count.retail_price)" @input="sendParameter()" v-model="count.retail_price" disabled outlined></v-text-field>
                </div>
                <div class="mt-3 mr-1" v-if="count.unit_id != null">
                  <v-text-field color="#8cc63e" type="number" pattern="[0-9]*" label="ราคาปลีก"  hide-details="auto" @keypress="isCurrency($event, count.retail_price)" @input="sendParameter()" v-model="count.retail_price" outlined></v-text-field>
                </div>

                <div class="mt-3 mr-1" v-if="count.unit_id == null">
                  <v-text-field color="#8cc63e" type="number" pattern="[0-9]*" label="ราคาส่ง(จ่ายสด)" hide-details="auto" @keypress="isCurrency($event, count.cash_price)" @input="sendParameter()" v-model="count.cash_price" disabled outlined></v-text-field>
                </div>
                <div class="mt-3 mr-1" v-if="count.unit_id != null">
                  <v-text-field color="#8cc63e" type="number" pattern="[0-9]*" label="ราคาส่ง(จ่ายสด)" hide-details="auto" @keypress="isCurrency($event, count.cash_price)" @input="sendParameter()" v-model="count.cash_price" outlined></v-text-field>
                </div>

                <div class="mt-3 mr-1 d-flex" v-if="count.unit_id == null">
                  <v-text-field color="#8cc63e" type="number" pattern="[0-9]*" label="ราคาส่ง(เครดิต)" hide-details="auto" @keypress="isCurrency($event, count.credit_price)" @input="sendParameter()" v-model="count.credit_price" disabled outlined></v-text-field>
                  <div class="ml-4" v-if="getCondition_list.length >= 1">
                    <v-btn @click="deleteCondition(count.id,count.create_id)" height="55" class="grad-danger-bg white--text"><v-icon>mdi-delete-empty-outline</v-icon></v-btn>
                  </div>
                </div>
                <div class="mt-3 mr-1 d-flex" v-if="count.unit_id != null">
                  <v-text-field color="#8cc63e" type="number" pattern="[0-9]*" label="ราคาส่ง(เครดิต)" hide-details="auto" @keypress="isCurrency($event, count.credit_price)" @input="sendParameter()" v-model="count.credit_price" outlined></v-text-field>
                  <div class="ml-4" v-if="getCondition_list.length >= 1">
                    <v-btn @click="deleteCondition(count.id,count.create_id)" height="55" class="grad-danger-bg white--text"><v-icon>mdi-delete-empty-outline</v-icon></v-btn>
                  </div>
                </div>

              </div>
            </div>
            <div class="mt-4">
              <v-btn height="55" @click="createCondition()" class="white--text grad-success-bg btn_mobile">เพิ่มเงื่อนไขพิเศษ</v-btn>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios.js";
import {onlyForCurrency, onlyForNumber} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  name: "Special_Condition",
  emits: ['submitSpecialCondition'],
  data() {
    return {
      name: null,
      loading_page: false,
      alert_success: false,
      alert_danger: false,
      typeItems: [],
      selected: null,
      conditionList: [],
      getCondition_list: [],
      getUnit_condition: [],
      id: 0,
      arr_all: [],
      create_id:1,
    }
  },
  methods: {
    checkLoading() {
      const pro_id = this.$route.params.id;
      this.loading_page = true
      HTTP.post('/setconditioncustomer/getConditionMoreAbout', {
        product_id: pro_id,
      }).then((res) => {
        if (res.data.success === true){
          this.loading_page = false
          this.getUnit_condition = res.data.object.unit_select
          this.getCondition_list = res.data.object.condition
          // console.log(this.getCondition_list)
        }
      })
    },
    isOnlyNumber: function (evt) {
      return onlyForNumber(evt)
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    createCondition() {
      const pro_id = this.$route.params.id;
      const arr_all = [];
      let condition_id = this.id += 1;
      this.conditionList.push({
        id: condition_id,
        more_amount: null,
        unit_id: null,
        retail_price: null,
        cash_price: null,
        credit_price: null,
      })
      this.conditionList.forEach((details) => {
        arr_all.push({
          id: details.id,
          more_amount: details.more_amount,
          unit_id: details.unit_id,
          retail_price: details.retail,
          cash_price: details.cash,
          credit_price: details.credit,
        })
      })
      this.getCondition_list.push({
        create_id: this.create_id,
        product_id:pro_id,
        more_amount: null,
        unit_id: null,
        retail_price: null,
        cash_price: null,
        credit_price: null,
      })
      this.create_id++
      
      // const arr_filter = arr_all.at(-1);
      // this.alert_success = true;
      // setTimeout(() => this.alert_success = false, 2000);
      // console.log(arr_filter)
      // HTTP.post('/setconditioncustomer/createConditionMoreAbout', {
      //   product_id: pro_id,
      //   more_amount: arr_filter.more_amount,
      //   unit_id: arr_filter.unit_id,
      //   cash_price: arr_filter.cash,
      //   credit_price: arr_filter.credit,
      //   retail_price: arr_filter.retail,
      // }).then((res) => {
      //   if (res.data.success === true) {
      //     this.getSpecialCondition();
      //   }
      // })
    },
    getSpecialCondition() {
      const pro_id = this.$route.params.id;
      HTTP.post('/setconditioncustomer/getConditionMoreAbout', {
        product_id: pro_id,
      }).then((res) => {
        if (res.data.success === true){
          this.getUnit_condition = res.data.object.unit_select
          this.getCondition_list = res.data.object.condition;
        }
      })
    },
    // sendParameter(id, more_amount, unit_id ,retail_price, cash_price, credit_price) {
    sendParameter() {
      this.$emit('submitSpecialCondition',this.getCondition_list)
      // if (this.timer) {
      //   clearTimeout(this.timer);
      //   this.timer = null;
      //   this.alert_success = true;
      // }
      // this.timer = setTimeout(() => {
      //   this.alert_success = false;
      //   HTTP.post('/setconditioncustomer/updateConditionMoreAbout', {
      //     product_id: this.$route.params.id,
      //     id: id,
      //     more_amount: more_amount,
      //     unit_id: unit_id,
      //     retail_price: retail_price,
      //     cash_price: cash_price,
      //     credit_price: credit_price,
      //   }).then((res) => {
      //     if (res.data.success === true) {
      //       setTimeout(() => this.alert_success = false, 2000);
      //     }
      //   })
      // }, 1000);
    },
    deleteCondition(id,createId) {
      // this.conditionList = this.conditionList.filter(detail => detail.id !== id);
      // HTTP.post('/setconditioncustomer/deleteConditionMoreAbout', {
      //   id: id
      // }).then((res) => {
      //   if (res.data.success === true){
      //     this.alert_danger = true;
      //     setTimeout(() => this.alert_danger = false, 2000);
      //     this.getSpecialCondition();
      //   }
      // })
      if(createId){
        this.getCondition_list = this.getCondition_list.filter(detail => detail.create_id !== createId)
      }
      else{
        this.getCondition_list = this.getCondition_list.map((detail) => {
        if(detail.id === id){
          return {
            ...detail,
            is_delete: 1
          }
        }
        else return detail
      })
      }
      
      this.sendParameter()
    },
    getType_unit() {
      HTTP.get('/products/units/all')
          .then((res) => {
            if (res.data.success === true){
              this.typeItems = res.data.object;
            }
          })
    }
  },
  beforeMount() {
    this.checkLoading();
  },
  mounted() {
    this.getType_unit();
    this.getSpecialCondition();
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.grid_col {
  display: grid;
  grid-template-columns: 18% 15% 20% 20% 27%;
}
@media only screen and (max-width: 1100px) {
  .grid_col {
    display: grid;
    grid-template-columns: 50% 50%;
  }
}
@media only screen and (max-width: 600px) {
  .grid_col {
    display: grid;
    grid-template-columns: 100%;
  }
  .btn_mobile {
    width: 100%;
  }
}
</style>
